import { GroupChat } from '../models/GroupChat';
import { FakeData } from './FakeData';
import { Repository } from './Repository';

export class GroupRepository extends Repository {

  async getGroupDetails(id: string, channelType: string = 'group', currentUserId: string, excludeMembers: boolean = false): Promise<GroupChat> {
    if(Repository.offlineMode) {
      return FakeData.getGroupChat();
    }

    const path = `v1/chats/groups/${id}?excludeMembers=${excludeMembers}&channelType=${channelType}`;

    try {
      const response = await Repository.client.get(path);
      return GroupChat.fromJson(response.data.data.groupChat, currentUserId);
    } catch (err) {
      throw err;
    }
  }
}

// Create a singleton instance
export const groupRepository = new GroupRepository();